import isEmpty from 'lodash-es/isEmpty';
import isNil from 'lodash-es/isNil';
import { useState } from 'react';
import { useClient } from '../../../ClientProvider';
import { mergeQueryState } from '../../../mergeState';
import queryClient from '../../../queryClient';
import useQuery from '../../../useQuery';
import { useHasNotConfiguredPlot } from './useHasNotConfiguredPlot';
export const useDecitraitPlotConfiguration = (plot) => {
    const client = useClient();
    const [form, setForm] = useState(null);
    const { id: plotId, organizationId: orgId } = plot;
    const { hasNotConfiguredPlot, refetch: hasNotConfiguredPlotRefetch, summaryRequest } = useHasNotConfiguredPlot({
        plotId
    });
    const genericError = summaryRequest.error?.status === 400 && summaryRequest.error.message.includes('"message":"-9"');
    const decitraitPlotsRequest = useQuery(client.decitrait.plots({ organizationId: orgId }), {
        enabled: !isNil(orgId)
    });
    const orgRequest = useQuery(client.orgs.get(orgId), { enabled: !isNil(orgId) });
    const { isLoading } = mergeQueryState(decitraitPlotsRequest, orgRequest, summaryRequest);
    const org = orgRequest.data;
    const decitraitPlots = decitraitPlotsRequest.data;
    const handleLinkFormPress = () => setForm('link-plot');
    const handleCreateFormPress = () => setForm('create-plot');
    const onPlotCreationSuccess = () => {
        decitraitPlotsRequest.refetch();
        hasNotConfiguredPlotRefetch();
        queryClient.invalidateQueries({
            queryKey: [client.decitrait.plotDetail({ plotId: plot.id }).key]
        });
        setForm('link-plot');
    };
    const isCreateForm = form === 'create-plot';
    const isLinkForm = form === 'link-plot';
    const shouldShowLinkPlotButton = !isEmpty(decitraitPlots) && !isLinkForm;
    return {
        form,
        handleCreateFormPress,
        handleLinkFormPress,
        hasNotConfiguredPlot,
        isCreateForm,
        isLinkForm,
        isLoading,
        onPlotCreationSuccess,
        org,
        shouldShowLinkPlotButton,
        genericError
    };
};
